module.exports = __webpack_public_path__ + "img/Epic.ff9017ac.png";